import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';             // 全局兼容性与基础样式
import 'antd/dist/reset.css';     // Ant Design 重置样式
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/locale/zh_TW';

// 找到根节点
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

// 创建 React root
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider locale={zhTW}>
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
